export type CheckoutNavigationOptions = {
  correlationId?: string;
  programId?: string;
  straightToCheckout?: boolean;
  courseRunKey?: string;
};

const CHECKOUT_BASE_PATH = '/checkout/';

const getCorrelationIdFromLocation = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return (
    new URLSearchParams(window.location.search).get('correlationId') ??
    undefined
  );
};

const getStraightToCheckoutFromLocation = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  return (
    new URLSearchParams(window.location.search).get('straightToCheckout') ===
    'true'
  );
};

const getCourseRunKeyFromLocation = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return (
    new URLSearchParams(window.location.search).get('course_run_key') ??
    undefined
  );
};

export const buildCheckoutUrl = (
  opts: CheckoutNavigationOptions = {},
): string => {
  const {
    programId,
    correlationId: providedCorrelationId,
    straightToCheckout: isStraightToCheckoutProvided,
    courseRunKey: providedCourseRunKey,
  } = opts;
  const correlationId = providedCorrelationId ?? getCorrelationIdFromLocation();
  const isStraightToCheckout =
    isStraightToCheckoutProvided ?? getStraightToCheckoutFromLocation();
  const courseRunKey = providedCourseRunKey ?? getCourseRunKeyFromLocation();

  const params = new URLSearchParams();
  if (programId) {
    params.set('bundle', programId);
  }
  if (correlationId) {
    params.set('correlationId', correlationId);
  }
  if (isStraightToCheckout) {
    params.set('straightToCheckout', 'true');
  }
  if (courseRunKey && !programId) {
    params.set('course_run_key', courseRunKey);
  }

  const qs = params.toString();
  return qs ? `${CHECKOUT_BASE_PATH}?${qs}` : CHECKOUT_BASE_PATH;
};

export const redirectToCheckout = (
  router: { replace: (url: string) => void },
  opts: CheckoutNavigationOptions = {},
): void => {
  router.replace(buildCheckoutUrl(opts));
};
